$(function() { 
    $(window).scroll(function () {
      if (window.matchMedia('(min-width: 981px)').matches) {
        if ($(this).scrollTop() > 500) {
            $(".sidebar_wrap").addClass("fixed");
            $(".main").addClass("mar-left");
        } else {
            $(".sidebar_wrap").removeClass("fixed");
            $(".main").removeClass("mar-left");
        }
      }
      else{
        ;
      }
    });
});

//マイページ：注文ステータスがunfulfilledのとき、ダウンロードボタンを非表示
$(document).ready(function() {
  $('#order-history td.status').each(function() {
    // テキストが「unfulfilled」の場合のみ処理を行う
    if ($(this).text().trim() === 'unfulfilled') {
      // 兄弟要素の子要素aを非表示にする
      console.log("aaa");
      $(this).siblings('td.dl_pdf').find('a').hide();
    }
  });
});
